import { useEffect, useRef, useState } from "react";
import Logo from "../../assets/icons/mocionLogo.svg";
import HelpCenterIcon from "../../assets/icons/helpCenter.svg";
import CloseIcon from "../../assets/icons/deletewhite.svg";
import useOutsideClick from "../../hooks/useOutsideClick";
import { cn } from "../../utils/utils";
type Props = {
  openHelpCenter: boolean;
  setOpenHelpCenter: React.Dispatch<React.SetStateAction<boolean>>;
};
const hiddenPages = ["/chat"];
function HelpCenter({ openHelpCenter, setOpenHelpCenter }: Props) {
  const divRef = useRef<HTMLDivElement>(null);
  const [name, setName] = useState("unknown");
  useOutsideClick(divRef, () => {
    setOpenHelpCenter(false);
  });
  useEffect(() => {
    const info = window.localStorage.getItem("generalInfo");
    if (info) {
      setName(JSON.parse(info)?.name);
    }
  }, []);

  return (
    <div
      ref={divRef}
      className="fixed  bottom-3 right-10 group flex justify-end flex-col items-end gap-2 z-50 "
    >
      <div
        className={cn(
          "box w-[300px] h-[400px]  help-center-shadow bg-white rounded-md gap-2",
          openHelpCenter ? "flex flex-col" : "hidden"
        )}
      >
        <div className="header bg-primary p-2 w-full text-[#f3f3f3] flex justify-between items-center">
          <h3 className="flex gap-2">
            <img loading="lazy" src={HelpCenterIcon} alt="" width={25} height={25} />
            Help center
          </h3>
          <img loading="lazy"
            src={CloseIcon}
            alt=""
            width={20}
            height={20}
            onClick={() => {
              setOpenHelpCenter(false);
            }}
            className="cursor-pointer"
          />
        </div>
        <div className="content">
          <div className="welcome-area flex w-full flex-col gap-3 justify-center items-center p-2">
            <img loading="lazy" src={Logo} alt="" width={90} height={90} />
            <h3 className="font-bold text-primary dark:text-white text-lg">
              Hi, {name}! How can we help you?
            </h3>
          </div>
        </div>
      </div>
      {openHelpCenter && (
        <img loading="lazy"
          src={Logo}
          alt=""
          width={50}
          height={50}
          className={cn(
            "cursor-pointer invisible group-hover:visible",
            openHelpCenter && "visible"
          )}
          onClick={(e) => {
            setOpenHelpCenter((prev) => !prev);
          }}
        />
      )}
    </div>
  );
}

export default HelpCenter;
